<script setup>
import { ref, onMounted, watch } from 'vue';
import { X, ChefHat } from 'lucide-vue-next';
import { APP_STORE_URL, PLAY_STORE_URL } from '../lib/appLinks';

const emit = defineEmits(['visible']);
const showBanner = ref(false);
const isIOSDevice = ref(false);
const isAndroidDevice = ref(false);

watch(showBanner, (val) => emit('visible', val));

const dismiss = () => {
  showBanner.value = false;
  localStorage.setItem('app_banner_dismissed', Date.now().toString());
};

onMounted(() => {
  const ua = window.navigator.userAgent.toLowerCase();
  isIOSDevice.value = /iphone|ipad|ipod/.test(ua);
  isAndroidDevice.value = /android/.test(ua);

  // Deja en PWA standalone : ne rien promouvoir
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                       window.navigator.standalone === true;
  if (isStandalone) return;

  // Rejetee il y a moins de 24h : rester discret
  const dismissed = localStorage.getItem('app_banner_dismissed');
  if (dismissed && Date.now() - parseInt(dismissed) < 86400000) return;

  showBanner.value = true;
});
</script>

<template>
  <div v-if="showBanner" class="fixed top-14 left-0 right-0 z-40 bg-[#ffd93e] text-gray-800 shadow-md animate-slide-down md:hidden">
    <div class="flex items-center justify-between p-3 px-4">
      <div class="flex items-center gap-3">
        <div class="bg-white rounded-[10px] shrink-0 overflow-hidden shadow-sm border border-gray-100">
          <img src="/web-app-manifest-192x192.png" alt="Clo'Cook" class="w-9 h-9 object-cover" />
        </div>
        <div class="flex flex-col">
          <div class="flex items-center gap-1">
            <span class="text-xs font-bold leading-tight text-gray-900">L'app Clo'Cook est là</span>
            <ChefHat class="w-3 h-3 text-gray-900" />
          </div>
          <span class="text-xs opacity-80 leading-tight text-gray-700">
            {{ isIOSDevice ? 'Disponible sur l\'App Store' : (isAndroidDevice ? 'Disponible sur Google Play' : 'Sur l\'App Store et Google Play') }}
          </span>
        </div>
      </div>

      <div class="flex items-center gap-2">
        <a v-if="isIOSDevice" :href="APP_STORE_URL" target="_blank" rel="noopener"
           class="bg-black text-white text-xs font-bold px-3 py-1.5 rounded-full active:scale-95 transition-transform">
          App Store
        </a>
        <a v-else-if="isAndroidDevice" :href="PLAY_STORE_URL" target="_blank" rel="noopener"
           class="bg-black text-white text-xs font-bold px-3 py-1.5 rounded-full active:scale-95 transition-transform">
          Google Play
        </a>
        <RouterLink v-else to="/application" @click="dismiss"
           class="bg-black text-white text-xs font-bold px-3 py-1.5 rounded-full active:scale-95 transition-transform">
          Télécharger
        </RouterLink>
        <button @click="dismiss" aria-label="Fermer la bannière" class="p-3 -mr-2 opacity-50 hover:opacity-100">
          <X class="w-5 h-5" />
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.animate-slide-down {
  animation: slideDown 0.3s ease-out forwards;
}

@keyframes slideDown {
  from { transform: translateY(-100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
</style>
